/** Launch the MiniApp directly without replacing the browser login page. */
export interface TelegramLinks {
  deepLink: string
  webLink: string
}

export function miniAppLinks(bot: string, startParam: string): TelegramLinks {
  const query = startParam ? `&startapp=${encodeURIComponent(startParam)}` : ''
  return {
    deepLink: `tg://resolve?domain=${encodeURIComponent(bot)}${query}`,
    webLink: startParam
      ? `https://t.me/${bot}?startapp=${encodeURIComponent(startParam)}`
      : `https://t.me/${bot}`,
  }
}

export function openTelegram(links: TelegramLinks, target: Window = window): void {
  target.location.href = links.deepLink
  target.setTimeout(() => {
    if (target.document.visibilityState === 'visible') {
      target.open(links.webLink, '_blank', 'noopener,noreferrer')
    }
  }, 1200)
}
